import { render } from "./questionItem.vue?vue&type=template&id=e20bc6d0&scoped=true"
import script from "./questionItem.vue?vue&type=script&lang=js"
export * from "./questionItem.vue?vue&type=script&lang=js"

import "./questionItem.vue?vue&type=style&index=0&id=e20bc6d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e20bc6d0"]])

export default __exports__